/*
 * Grid Swipe — Lightweight 2-image product card swipe
 * Uses native CSS scroll-snap. JS only prevents link click during swipe.
 */
(function () {
  'use strict';

  function initSwipe(container) {
    if (container.dataset.swipeInit) return;
    container.dataset.swipeInit = '1';

    var track = container.querySelector('.grid-swipe__track');
    if (!track) return;

    var isDown = false;
    var startX = 0;
    var didSwipe = false;

    // Prevent link navigation when swiping
    var link = container.closest('a');
    if (link) {
      track.addEventListener('pointerdown', function (e) {
        isDown = true;
        startX = e.clientX;
        didSwipe = false;
      }, { passive: true });

      track.addEventListener('pointermove', function (e) {
        if (isDown && Math.abs(e.clientX - startX) > 8) {
          didSwipe = true;
        }
      }, { passive: true });

      track.addEventListener('pointerup', function () {
        isDown = false;
      }, { passive: true });

      track.addEventListener('pointercancel', function () {
        isDown = false;
      }, { passive: true });

      link.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.grid-swipe').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('page:loaded', initAll);
  document.addEventListener('ajaxinate:loaded', initAll);
})();
